import React, { Component } from "react";
import Table from "../components/Table";
import { connect } from "react-redux";
import { mapKV } from "../utils/map";
import { ExternalAppInfoDialog } from "../dialogs/ExternalAppInfoDialog";
import { AreYouSureDialog } from "../dialogs/AreYouSureDialog";
import AddExternalApp from "../containers/AddExternalApp";
import UploadingFilesProgress from "../containers/UploadingFilesProgress";
import EditExternalApp from "../containers/EditExternalApp";
import { deleteApp } from "../redux/actions/appActions";
import { isCurrentUserSuperAdmin } from "../utils/userRoles";
import { EXTERNAL_APPS, createInfoUrl } from "../utils/routes";

export class externalAppsPage extends Component {
    state = {
        showAddDialog: false,
        showEditDialog: false,
        showAreYouSureDialog: false
    };

    headers = () => {
        let h = [
            { id: 0, title: "", sortable: false },
            { id: 1, title: "Title", sortable: true },
            { id: 2, title: "Package Name", sortable: true }
        ];

        if (isCurrentUserSuperAdmin())
            h.push({ id: 3, title: "Organization", sortable: true });

        return h;
    };

    extractData = () => {
        const { apps, organizations } = this.props;
        let data = [];
        mapKV(apps, (key, { apkUrl, iconUrl, title, packageName, organizationRef }) => {
            if (!!apkUrl) return;

            const row = [<img src={iconUrl} style={{ width: 50 }} />, title, packageName];
            let searching = [title, packageName].join(" ");

            if (isCurrentUserSuperAdmin()) {
                const orgName = organizations[organizationRef.id].name;
                row.push(orgName);
                searching += " " + orgName;
            }

            data.push({
                title,
                key,
                row,
                searching
            });
        });
        return data;
    };

    render() {
        const { showAddDialog, showEditDialog, showAreYouSureDialog } = this.state;
        const { apps, loading, uploading, uploadingTitle, deleteApp } = this.props;

        const { history, match } = this.props;
        const { selectedKey } = match.params;

        return (
            <div>
                {showAddDialog && (
                    <AddExternalApp onClose={() => this.setState({ showAddDialog: false })} />
                )}

                {selectedKey && apps[selectedKey] && !showEditDialog && (
                    <ExternalAppInfoDialog
                        onClose={() => history.push(EXTERNAL_APPS)}
                        onEdit={() => this.setState({ showEditDialog: true })}
                        onDelete={() => this.setState({ showAreYouSureDialog: true })}
                        app={apps[selectedKey]}
                        loading={loading}
                    />
                )}

                {showAreYouSureDialog && (
                    <AreYouSureDialog
                        onClose={() => this.setState({ showAreYouSureDialog: false })}
                        onDelete={() => {
                            this.setState({ showAreYouSureDialog: false });
                            history.push(EXTERNAL_APPS);
                            deleteApp(selectedKey);
                        }}
                        title={apps[selectedKey].title}
                    />
                )}

                {showEditDialog && (
                    <EditExternalApp
                        onClose={() => this.setState({ showEditDialog: false, showInfoDialog: true })}
                        app={apps[selectedKey]}
                        selectedKey={selectedKey}
                    />
                )}

                {uploading && <UploadingFilesProgress title={uploadingTitle} />}

                <Table
                    title="External Apps"
                    subtitle="External Apps are not directly managed by the Mighty Platform, and cannot be installed, updated, or uninstalled
          automatically. Approved External Apps that are installed on a device will appear in the Mighty Launcher, but installing the external app must be done manually. Often times an external app is a curated
          app from an App Store."
                    headers={this.headers()}
                    rows={this.extractData()}
                    addNewTitle="New External App"
                    onAddNewClick={() => this.setState({ showAddDialog: true })}
                    onRowClick={key => history.push(createInfoUrl(EXTERNAL_APPS, key))}
                    loading={loading}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    apps: state.data.apps,
    loading: state.ui.loading,
    uploading: state.ui.uploading,
    uploadingTitle: state.ui.uploadingTitle,
    organizations: state.data.organizations
});

const mapDispatchToProps = { deleteApp };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(externalAppsPage);
